/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Entity} from '@ion/core/src/types/entities';
import {errorEditOptions, successEditOptions} from '../../../prompts/constants';
import {toggleUserPrompt} from '../../../store/actions/user-prompt';

export const useSaveStatusPrompt = (isSaveSuccess, isSaveError) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isSaveSuccess) {
      dispatch(toggleUserPrompt(successEditOptions(Entity.emissionTester)));
    }
    if (isSaveError) {
      dispatch(toggleUserPrompt(errorEditOptions(Entity.emissionTester)));
    }
  }, [isSaveSuccess, isSaveError]);
};

export default useSaveStatusPrompt;
